import {Vue, Component} from 'vue-property-decorator';
import {
  CommonData,
  AccountData,
  Banner
} from '@/types/banner';
import {CheckBoxOptions, RadioBoxOptions} from '@/types';
import moment from 'moment'

@Component
export default class BannerListStaticData extends Vue{
  protected readonly platformDisplayOptions: RadioBoxOptions = {
    name: 'platformDisplayOptions',
    data: [
      {
        id: 'platformDisplayYn1',
        value: 'NONE',
        dispaly: 'COMMON_ALL',
      },
      {
        id: 'platformDisplayYn2',
        value: 'ANY',
        dispaly: 'COMMON_SETTING',
      },
    ],
  };

  protected readonly memberGradeDisplayOptions = {
    name: 'memberGradeDisplayOptions',
    data: [
      {
        id: 'memberGradeDisplayYn1',
        value: 'NONE',
        dispaly: 'COMMON_NOT_SETTING',
      },
      {
        id: 'memberGradeDisplayYn2',
        value: 'ANY',
        dispaly: 'COMMON_SETTING',
      },
    ],
  };

  protected readonly memberGroupDisplayOptions = {
    name: 'memberGroupDisplayOptions',
    data: [
      {
        id: 'memberGroupDisplayYn1',
        value: 'NONE',
        dispaly: 'COMMON_NOT_SETTING',
      },
      {
        id: 'memberGroupDisplayYn2',
        value: 'ANY',
        dispaly: 'COMMON_SETTING',
      },
    ],
  };

  protected readonly memberGradeDetailDisplayOptions: CheckBoxOptions = {
    name: 'memberGradeDetailDisplayOptions',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: this.$t('BANNER_LIST_ALL_GRADES'),
      },
    ],
  };

  protected readonly memberGroupDetailDisplayOptions: CheckBoxOptions = {
    name: 'memberGroupDetailDisplayOptions',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: this.$t('BANNER_LIST_ALL_GROUPS'),
      },
    ],
  };

  // 랜딩 URL 옵션
  protected readonly landingUrlTypes = [
    { value: 'GENERAL', name: 'BANNER_LIST_DEFAULT' },
    { value: 'IMAGE_MAP', name: 'BANNER_LIST_IMAGE_MAP' },
    { value: 'EVENT', name: 'BANNER_LIST_THEME_DISPLAY' },
  ];

  // 현재 창, 새 창
  protected readonly openLocationTypes = [
    { value: 'CURRENT', name: 'BANNER_LIST_CURRENT_WINDOW' },
    { value: 'NEW', name: 'BANNER_LIST_NEW_WINDOW' },
  ];

  protected displayPeriodOptions(outerIndex: number, index: number): object {
    return {
      name: `displayPeriodOptions_${outerIndex}_${index}`,
      data: [
        {
          id: `displayPeriodYn1_${outerIndex}_${index}`,
          value: 'REGULAR',
          dispaly: 'BANNER_LIST_YMD_ALWAYS',
        },
        {
          id: `displayPeriodYn2_${outerIndex}_${index}`,
          value: 'PERIOD',
          dispaly: 'BANNER_LIST_YMD_PERIOD',
        },
      ],
    };
  }

  protected defaultCommonData(): CommonData {
    return {
      title: '',
      numberOfCount: 1,
      sectionNo: 1,
      groupNo: 1,
      sectionCode: '',
      platformDisplay: {
        displayMobileWeb: true,
        displayMobile: true,
        displayPc: true,
      },
      memberGradeDisplay: {
        check: 'NONE',
        info: 'ALL',
      },
      memberGroupDisplay: {
        check: 'NONE',
        info: 'ALL',
      },
    }
  }

  protected defaultBannerData(order: number): Banner {
    const today = `${moment().format('YYYY-MM-DD')} 00:00:00`
    const endDay = `${moment().add('3', 'month').format('YYYY-MM-DD')} 23:59:59`

    return {
      bannerName: '',
      bannerNameColor: '#000000',
      bannerNo: 0,
      description: '',
      descriptionColor: '#000000',
      displayOrder: order,
      lastModificationDate: '',
      lastModifierName: '',
      lastModifierNo: 0,
      leftImageSpaceColor: '#ffffff',
      rightImageSpaceColor: '#ffffff',
      videoUrl: '',
      displayPeriod: {
        displayPeriod: {
          startYmdt: today,
          endYmdt: endDay
        },
        periodType: 'PERIOD',
      },
      imageInfo: {
        imageName: '',
        imageUrl: '',
      },
      landingUrlValue: {
        bannerOpenLocationType: 'CURRENT',
        landingUrl: '',
        landingUrlType: 'GENERAL',
      },
      useMouseOver: false,
      mouseOverImage: {
        imageName: '',
        imageUrl: '',
      },
    }
  }

  protected defaultAccountData(order: number, accountNo: number = 0): AccountData {
    return {
      accountName: '',
      accountNo: accountNo,
      displayType: 'RANDOM',
      height: null,
      memberGradeDisplayInfo: {
        check: 'NONE',
        info: '',
      },
      memberGroupDisplayInfo: {
        check: 'NONE',
        info: '',
      },
      platformDisplay: {
        displayMobileWebYn: 'Y',
        displayMobileYn: 'Y',
        displayPcYn: 'Y',
      },
      sectionNo: 0,
      width: null,
      banners: [
        this.defaultBannerData(order)
      ],
    }
  }

  protected defaultAccountsData(order: number): AccountData[] {
    return [
      this.defaultAccountData(order)
    ]
  }
}